import { useRouteError } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import RefreshIcon from "@mui/icons-material/Refresh";
import AuthView from "views/AuthView";
import { isChunkLoadError } from "./ErrorBoundary";

export default function RouteErrorElement() {
  const error = useRouteError();
  const { t } = useTranslation();

  const isChunkError = error instanceof Error && isChunkLoadError(error);

  if (isChunkError) {
    return (
      <Box
        sx={{
          bgcolor: "background.default",
          color: "text.primary",
          minHeight: "100vh",
        }}
      >
        <AuthView>
          <Typography variant="h5">
            {t("common.newVersionAvailable")}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            {t("common.newVersionDescription")}
          </Typography>
          <Button
            variant="contained"
            startIcon={<RefreshIcon />}
            sx={{ mt: 3 }}
            onClick={() => {
              window.location.reload();
            }}
          >
            {t("common.refresh")}
          </Button>
        </AuthView>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        minHeight: "100vh",
      }}
    >
      <AuthView>
        <Typography variant="h5">{t("common.somethingUnexpected")}</Typography>
        <Button
          variant="outlined"
          sx={{ mt: 3 }}
          onClick={() => {
            window.location.reload();
          }}
        >
          {t("common.tryAgain")}
        </Button>
      </AuthView>
    </Box>
  );
}
